import { useQuery } from "react-query";

import type { QueryOptionsArgs } from "api/schemas/common";
import { useApiClient } from "api/useApiClient";

export const queryKeyPrefix = "getTreatmentActivityLogs";

export const getTreatmentActivityLogsQueryKey = (args: QueryOptionsArgs) => [queryKeyPrefix, args];

export const useGetTreatmentActivityLogs = (args: QueryOptionsArgs) => {
  const client = useApiClient();

  return useQuery(getTreatmentActivityLogsQueryKey(args), () => client.getTreatmentActivityLogs(args));
};
